import React from "react";

const SelectDate = ({
  name,
  label,
  placeholder,
  value,
  error,
  onChange,
  listKey,
  listName,
  ...rest
}) => {
  return (
    <div className="form-group">
      {label && <label htmlFor={name}>{label}</label>}
      <input
        className="form-control"
        value={value}
        onChange={onChange}
        name={name}
        id={name}
        type="date"
        {...rest}
      >
      </input>
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default SelectDate;
